const types = {
   USER_LOADING: 'USER_LOADING',
   USER_SEND_PROMPT_MODE1: 'USER_SEND_PROMPT_MODE1',
   USER_RECEIVE_COMPLETION: 'USER_RECEIVE_COMPLETION',
   USER_SEND_PROMPT_MODE0: 'USER_SEND_PROMPT_MODE0',
   USER_RECEIVE_IMAGE: 'USER_RECEIVE_IMAGE',

   USER_SET_PROMPTS_MODE1: 'USER_SET_PROMPTS_MODE1',
   USER_SET_PROMPTS_MODE0: 'USER_SET_PROMPTS_MODE0',

   USER_CLEAR: 'USER_CLEAR',
   USER_CLEAR_MODE1: 'USER_CLEAR_MODE1',
   USER_CLEAR_MODE0: 'USER_CLEAR_MODE0',
}

export default types
